import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  listCases: () => client.get("/cases").then((r) => r.data),
  getCase: (id) => client.get(`/cases/${id}`).then((r) => r.data),
  createCase: (payload) => client.post("/cases", payload).then((r) => r.data),
  deleteCase: (id) => client.delete(`/cases/${id}`).then((r) => r.data),
  generateQuestions: (id) => client.post(`/cases/${id}/questions`).then((r) => r.data),
  saveAnswers: (id, answers) => client.put(`/cases/${id}/answers`, { answers }).then((r) => r.data),
  provisional: (id) => client.post(`/cases/${id}/provisional-diagnosis`).then((r) => r.data),
  investigations: (id) => client.post(`/cases/${id}/investigations`).then((r) => r.data),
  saveResults: (id, rows) => client.put(`/cases/${id}/investigation-results`, { answers: rows }).then((r) => r.data),
  finalDiagnosis: (id) => client.post(`/cases/${id}/final-diagnosis`).then((r) => r.data),
  carePlan: (id) => client.post(`/cases/${id}/care-plan`).then((r) => r.data),
  followUp: (id) => client.post(`/cases/${id}/follow-up`).then((r) => r.data),
  override: (id, field, value) => client.put(`/cases/${id}/override`, { field, value }).then((r) => r.data),
  addVisit: (id, visit) => client.post(`/cases/${id}/visits`, visit).then((r) => r.data),
  deleteVisit: (id, visitId) => client.delete(`/cases/${id}/visits/${visitId}`).then((r) => r.data),
  patientSummary: (id) => client.post(`/cases/${id}/patient-summary`).then((r) => r.data),
  getPublicCase: (id) => client.get(`/cases/${id}/public`).then((r) => r.data),
};
